import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { useTranslation } from 'react-i18next';
import { putReverseSearchEmailNotifyApi } from '@/lib/service/image-search';

const SendEmailModal: React.FC<{ taskId: number }> = ({ taskId }) => {
  const { t } = useTranslation();
  const [isEmailNotify, setIsEmailNotify] = useState(true);

  const handleChange = () => {
    setIsEmailNotify(!isEmailNotify);
  };

  useEffect(() => {
    if (taskId) {
      putReverseSearchEmailNotifyApi({
        task_id: taskId,
        email_notify: isEmailNotify,
      });
    }
  }, [taskId, isEmailNotify]);

  return (
    <label className={styles.container}>
      <input type="checkbox" className={styles.checkbox} checked={isEmailNotify} onChange={handleChange} />
      <span className={styles.text}>{t('Email me when complete. Results are typically ready in 2-5 minutes.')}</span>
    </label>
  );
};

export default SendEmailModal;
